module.exports = new __parcel__URL__("report-pie-chart.c26eec16.svg").toString();